import {
    LookupItemModel,
    TransactionDetailResponseModel,
    TransactionItemResponseModel
} from "../../../../models";
import {getLookUpItemValue, updateStateDynamically} from "../../../../utils";
import {
    getAccountBalance,
    getCurrencyValueEntity, getItemTaxPercentageValue,
    handleCalculateNewItemDiscountValuesChange,
    handleCalculateNewItemValuesChange,
    handleTransactionTotalValuesByTransactionItems,
    updateTransactionItemsCurrencyValueAndReCalculateAllValues
} from "../businessLogic/transactionBl";
import {getItemSalesPrice} from "../businessLogic/commonBl";
export const handleCurrencySelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel,
    transactionItemObject: TransactionItemResponseModel | null,
    beneficiaryList: LookupItemModel[],
    itemList: LookupItemModel[],
    currencyList: LookupItemModel[],
    updateTransactionItemObjectState: (
        key?: string | null,
        value?: any | null,
        keyValues?: { key: string; value: any }[] | null
    ) => Promise<void>
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    if (val == null) {
        setLocalData({...localData, Currency_ID: Number(val)});
        return;
    }

    const currencyValueEntity = getCurrencyValueEntity(Number(val), currencyList);
    const balance = await getAccountBalance(
        localData.Customer_ID ?? 0,
        Number(val),
        beneficiaryList
    );

    const itemPriceCalculatedValues = handleCalculateNewItemValuesChange(
        itemList,
        transactionItemObject?.ItemInstore_ID ?? 0,
        transactionItemObject?.Unit_Price ?? 0,
        currencyValueEntity,
        true,
        false
    );

    const discountCalculatedValues = handleCalculateNewItemDiscountValuesChange(
        transactionItemObject?.ItemDiscount ?? 0,
        currencyValueEntity,
        false
    );

    await updateTransactionItemObjectState(null, null, [
        { key: "Unit_Price", value: itemPriceCalculatedValues.UnitPrice },
        { key: "UnitPriceWithTaxCalculated", value: itemPriceCalculatedValues.UnitPriceWithTax },
        { key: "Unit_PriceInCurrencyCalculated", value: itemPriceCalculatedValues.UnitPriceInCurrency },
        { key: "UnitPriceWithTaxInCurrency", value: itemPriceCalculatedValues.UnitPriceWithTaxInCurrency },
        { key: "ItemDiscount", value: discountCalculatedValues.ItemDiscount },
        { key: "ItemDiscountInCurrency", value: discountCalculatedValues.ItemDiscountInCurrency },
        { key: "ValueOfCurrency", value: currencyValueEntity },
    ]);

    const transactionItems = updateTransactionItemsCurrencyValueAndReCalculateAllValues(
        localData.TransactionDetaillist,
        currencyValueEntity
    );

    const transactionValues = handleTransactionTotalValuesByTransactionItems(transactionItems);

    await updateStateDynamically(setLocalData, localData, null, null, [
        { key: "Currency_ID", value: val },
        { key: "ValueCurrency", value: currencyValueEntity },
        { key: "balance", value: balance },
        { key: "TotalMony", value: transactionValues.totalMoney },
        { key: "TotalNet", value: transactionValues.totalNet },
        { key: "TotalTax", value: transactionValues.totalTax },
        { key: "Discount", value: transactionValues.totalDiscount },
        { key: "TotalMonyInCurrency", value: transactionValues.totalMoneyInCurrency },
        { key: "TotalNetInCurrency", value: transactionValues.totalNetInCurrency },
        { key: "TotalTaxInCurrency", value: transactionValues.totalTaxInCurrency },
        { key: "DiscountInCurrency", value: transactionValues.totalDiscountInCurrency },
        { key: "discountRatio", value: transactionValues.totalDiscountPercentage },
        { key: "TransactionDetaillist", value: transactionItems },
    ]);
};

export const handleBeneficiarySelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel,
    beneficiaryList: LookupItemModel[]
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    let balance = 0;
    if (val !== null) {
        balance = await getAccountBalance(
            Number(val),
            localData.Currency_ID ?? null,
            beneficiaryList
        );
    }
    setLocalData({ ...localData, Customer_ID: Number(val), balance });
};

export const handleCalcTypeSelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel,
    transactionItemObject: TransactionItemResponseModel | null,
    itemList: LookupItemModel[],
    userTransactionSetting: any
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    if (val == null || !transactionItemObject){
        setLocalData({...localData, CalcType_ID: Number(val)});
        return;
    }
    const itemSalePrice = transactionItemObject.ItemInstore_ID
        ? getItemSalesPrice(
            transactionItemObject.ItemUnit_ID ?? 0,
            localData.TransactionType,
            Number(val),
            itemList,
            [],
            userTransactionSetting
        )
        : 0;

    const itemPriceCalculatedValues = handleCalculateNewItemValuesChange(
        itemList,
        transactionItemObject.ItemUnit_ID ?? 0,
        itemSalePrice,
        localData.ValueCurrency,
        true,
        false
    );

    const discountCalculatedValues = handleCalculateNewItemDiscountValuesChange(
        transactionItemObject.ItemDiscount,
        localData.ValueCurrency,
        false
    );

    await updateStateDynamically(setLocalData, localData, null, null, [
        { key: "TaxPercentge", value: getItemTaxPercentageValue(transactionItemObject.ItemUnit_ID ?? 0, itemList) },
        { key: "Unit_Price", value: itemPriceCalculatedValues.UnitPrice },
        { key: "UnitPriceWithTaxCalculated", value: itemPriceCalculatedValues.UnitPriceWithTax },
        { key: "Unit_PriceInCurrencyCalculated", value: itemPriceCalculatedValues.UnitPriceInCurrency },
        { key: "UnitPriceWithTaxInCurrency", value: itemPriceCalculatedValues.UnitPriceWithTaxInCurrency },
        { key: "ItemDiscount", value: discountCalculatedValues.ItemDiscount },
        { key: "ItemDiscountInCurrency", value: discountCalculatedValues.ItemDiscountInCurrency },
    ]);

    setLocalData({ ...localData, CalcType_ID: Number(val) });
};

export const handlePaymentTypeSelectChange = (
    setFieldValue: (field: string, value: any) => void,
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    setFieldValue("PaymentType_ID", e?.value ?? null);
    setLocalData({ ...localData, PaymentType_ID: Number(val) });
};

export const handleEmployeeSelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    setLocalData({ ...localData, Emp_ID: Number(val) });
};

export const handleCostCenterSelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    setLocalData({ ...localData, CostCenter_ID: Number(val) });
};
export const handlePaymentTypeForSupplierSelectChange = (
    setLocalData: React.Dispatch<React.SetStateAction<TransactionDetailResponseModel>>,
    localData: TransactionDetailResponseModel
) => async (e: LookupItemModel) => {
    const val = getLookUpItemValue(e);
    await updateStateDynamically(setLocalData, localData, null, null, [
        { key: "PaymentTypeIdForSupplier", value: val },
    ]);
};

